import { render, staticRenderFns } from "./EditarPlantilla.vue?vue&type=template&id=31ff75e2&scoped=true"
import script from "./EditarPlantilla.vue?vue&type=script&lang=js"
export * from "./EditarPlantilla.vue?vue&type=script&lang=js"
import style0 from "./EditarPlantilla.vue?vue&type=style&index=0&id=31ff75e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ff75e2",
  null
  
)

export default component.exports